import { Card, CardHeader, Avatar, CardMedia, CardActions, Button } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { IAttachment } from "../../common/models/IAttachment";
import { getAttachmentUrl } from "../../common/utilities/AttachmentHelpers";
import { useTranslation } from "react-i18next";

export enum AttachmentListCardActionEnum {
    View = 1,
    Download = 2
}

export type AttachmentListCardProps = {
    attachment: IAttachment;
    onAction?: (action: AttachmentListCardActionEnum, attachment: IAttachment) => void;
};

export default function AttachmentListCard({
    attachment,
    onAction
}: AttachmentListCardProps) {

    const { t } = useTranslation();

    return (
        <Card
            //id={id}
            sx={{
                maxWidth: theme => theme.spacing(25),
                padding: 0,
                paddingLeft: 1,
                paddingRight: 1
            }}
            raised={true}
        >
            <CardHeader
                title={attachment.fileName}
                avatar={
                    <Avatar aria-label="File Name">
                        <AttachFile />
                    </Avatar>
                }
                sx={{
                    padding: 1
                }}
                slotProps={{
                    title: {
                        variant: "body2"
                    }
                }}
            />
            {(attachment.mimeType === ApplicationMimeTypesEnum.JPEG ||
                attachment.mimeType === ApplicationMimeTypesEnum.PNG ||
                attachment.mimeType === ApplicationMimeTypesEnum.GIF) &&
                <CardMedia
                    component="img"
                    height="140"
                    image={getAttachmentUrl(attachment.base64Data, attachment.thumbnailUrl)}
                    alt={attachment.description}
                    onClick={() => {
                        onAction && onAction(AttachmentListCardActionEnum.View, attachment);
                    }}
                    sx={{
                        cursor: "zoom-in"
                    }}
                />
            }
            <CardActions sx={{justifyContent: 'flex-end'}}>
                {attachment.description}

                <Button size="small" onClick={() => {onAction && onAction(AttachmentListCardActionEnum.Download, attachment)}}>
                    {t('buttons.download')}
                </Button>

            </CardActions>
        </Card>
    );
}
